import { safeJson } from "src/app/helpers/Index";
import { faPencil } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Group, GroupUser, User } from "src/app/interfaces/Index";
import { UserService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import "./AdminUsers.css";
import { GroupService } from "src/app/services/GroupService";
import { GroupUserService } from "src/app/services/GroupUserService";

type Props = {};
type State = {
	isLoading: boolean;
	filters1: any;
	globalFilter: string;
	groups: Group[];
	groupUsers: GroupUser[];
	masterItems: User[];
	items: User[];
	selectedItem: User;
	selectedItems: User[];
	showDeleteModal: boolean;
	showDeleteSelectionModal: boolean;
	showItemInfoModal: boolean;
	submitted: boolean;
	viewMode: string;
	brokenAvatars: number[];
};

export class AdminUsers extends React.Component<Props, State> {
	dt: any;	
	toast: any;
	itemName: string = "User";
	itemNamePlural: string = "Users";

	constructor(props: Props) {
		super(props);
		this.state = {isLoading: false, filters1: {"global": { value: null, matchMode: FilterMatchMode.CONTAINS }}, globalFilter: "", groups:[], groupUsers: [], masterItems: [], selectedItem: new User(), selectedItems: [], items: [], showDeleteModal: false, showDeleteSelectionModal: false, showItemInfoModal: false, submitted: false, viewMode: "tiles", brokenAvatars: []};
	}

	categoryChange(e: any) {
		let selectedItem = {...this.state.selectedItem};
		// selectedItem.type = e.value;
		this.setState({selectedItem});
	}

	componentDidMount() {
		this.getItems();
	}

	deleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteItemConfirm(data)}></Button>
			</>
		);
	}

	deleteItemsFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteSelectionModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteSelectedItemConfirm()}></Button>
			</>
		);
	}

	deleteItemConfirm(rowData: any) {}

	deleteSelectedItemConfirm() {}

	itemInfoFooter() {
			return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({selectedItem: new User(), showItemInfoModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
			);
	}

	globalFilterChange(e: any) {
		let value = ""
		if (e !== ""){
			value = e.target.value;
			let newData = this.state.masterItems.filter(function(item){
				const haystack = `${item.emailAddress || ""} ${item.firstName || ""} ${item.lastName || ""}`.toLowerCase();
				return haystack.includes(value.toLowerCase());
			 });
			 this.setState({items:newData});
		} else this.setState({items:this.state.masterItems});
		this.setState({globalFilter:value});    
	}

	async getItems() {
		this.setState({isLoading: true});
		const res = await safeJson(UserService.getAll());
		if (res && res.error) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
		const groupRes = await safeJson(GroupService.getAll());
		const userAccess = await safeJson(GroupUserService.getAll());
		// Empty arrays, never null: render filters over these directly, and a
		// null would take the screen down rather than show it with no groups.
		this.setState({
			groupUsers: Array.isArray(userAccess) ? userAccess : [],
			groups: Array.isArray(groupRes) ? groupRes : [],
			isLoading: false,
			items: Array.isArray(res) ? res : [],
			masterItems: Array.isArray(res) ? res : []
		});
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new User({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedItem = new User({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{paddingTop: "1.5rem"}}>
							<h5 style={{paddingBottom: "1rem", paddingLeft: "1.5rem"}}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							{this.state.viewMode === "tiles" && this.renderTiles()}
							{this.state.viewMode === "list" &&
							<DataTable loading={this.state.isLoading} onSelectionChange={(e) => this.setState({selectedItems: e.value})} ref={(el) => this.dt = el} scrollable scrollHeight="flex" selection={this.state.selectedItems} style={{height: "calc(100vh - 17.5rem)"}} value={this.state.items}>
								<Column headerStyle={{width: 50}} selectionMode="multiple"></Column>
								<Column header="Avatar" body={(rowData: any) => this.renderAvatar(rowData, 44)}></Column>
								<Column field="emailAddress" header="Email" sortable></Column>
								<Column field="firstName" header="First Name" sortable ></Column>
								<Column field="lastName" header="Last Name" sortable ></Column>
								<Column style={{width: 75}} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({selectedItem: rowData, showItemInfoModal: true})} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
										</Button>
									</div>
								)}></Column>
							</DataTable>
							}
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%" }} visible={this.state.showItemInfoModal}>
								<TabView>
									<TabPanel header="Basic Information">
										<Row>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="avatarUrl" style={{ width: "100%" }}>User Profile</label>
													<div style={{ marginBottom: 10, marginTop: 10 }}>{this.renderAvatar(this.state.selectedItem, 90)}</div>
												</div>
											</Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="companyName">Company Name</label>
													<InputText id="companyName" readOnly value={this.state.selectedItem.emailAddress} />
												</div>
											</Col>
										</Row>
										<Row>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="primaryContactEmail">Primary Contact</label>
													<InputText id="primaryContactEmail" value={this.state.selectedItem.firstName} />
												</div>
											</Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="primaryAccountsEmail">Primary Contact</label>
													<InputText id="primaryAccountsEmail" value={this.state.selectedItem.lastName} />
												</div>
											</Col>
										</Row>
									</TabPanel>
									<TabPanel header="Address">
									</TabPanel>
									<TabPanel header="Access">
										Select the Areas that you wish the user to have access to...
										{this.renderAccess()}
									</TabPanel>
								</TabView>
							</Dialog>
						</div>
					</Col>
				</Row>
				<Toast ref={(el) => this.toast = el}></Toast>
			</>
		);
	}

	renderAvatar(user: any, size: number = 52) {
		const initials = `${(user.firstName || " ")[0] || ""}${(user.lastName || " ")[0] || ""}`.trim().toUpperCase() || "?";
		const usable = user.avatarUrl && !this.state.brokenAvatars.includes(user.id);
		if (usable) {
			return <img alt={initials} className="user-tile-avatar" onError={() => this.setState({ brokenAvatars: [...this.state.brokenAvatars, user.id] })} src={user.avatarUrl} style={{ height: size, width: size }}/>;
		}
		return <div className="user-tile-avatar user-tile-initials" style={{ fontSize: size * 0.38, height: size, width: size }}>{initials}</div>;
	}

	userStatusMeta(status: number) {
		switch (status) {
			case 10: return { className: "status-active", label: "Active" };
			case 20: return { className: "status-unverified", label: "Unverified" };
			case 30: return { className: "status-blacklisted", label: "Blacklisted" };
			case 40: return { className: "status-deleted", label: "Deleted" };
			default: return { className: "status-unverified", label: "Unknown" };
		}
	}

	userGroups(userId: number) {
		const memberships = this.state.groupUsers.filter((x: any) => x.userId === userId);
		return this.state.groups.filter((group: any) => memberships.some((m: any) => m.groupId === group.id)).map((group: any) => group.name);
	}

	renderTiles() {
		const items = Array.isArray(this.state.items) ? this.state.items : [];
		return (
			<div className="user-tiles">
				{items.map((user, i) => {
					const status = this.userStatusMeta(user.userStatus);
					return (
						<div className="user-tile" key={`user-tile-${i}`} onClick={() => this.setState({selectedItem: user, showItemInfoModal: true})}>
							<div className="user-tile-top">
								{this.renderAvatar(user)}
								<span className={`user-tile-status ${status.className}`}>{status.label}</span>
							</div>
							<div className="user-tile-name">{`${user.firstName || ""} ${user.lastName || ""}`.trim() || "(no name)"}</div>
							<div className="user-tile-email">{user.emailAddress}</div>
							<div className="user-tile-groups">
								{this.userGroups(user.id).map((name) => <span className="user-tile-group" key={name}>{name}</span>)}
							</div>
						</div>
					);
				})}
			</div>
		);
	}

	renderAccess() {
		let usersAccess = this.state.groupUsers.filter(x=>x.userId == this.state.selectedItem.id)
		if (!this.state.groups) return;
		return this.state.groups.map((data: any, i: number) => {
			return (
				<Row key={i}>
					<Col style={{alignItems: "center", display: "flex", height: 30}}>
						<div style={{fontSize: 14, width: 300, marginTop:25}}>{data.name}</div>
						<InputSwitch checked={usersAccess.filter(x=>x.groupId == data.id).length > 0} onChange={(e) => this.updateAccess(data.id, e.value)} style={{marginRight: 15, marginTop:25}}></InputSwitch>
					</Col>
				</Row>
			);
		});
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, marginRight: 10}} onClick={() => this.setState({selectedItem: new User(), showItemInfoModal: true})}></Button>
				<Button className={this.state.viewMode === "tiles" ? "" : "p-button-outlined"} icon="pi pi-th-large" label="Tiles" style={this.state.viewMode === "tiles" ? {backgroundColor: colours.primary, borderColor: colours.primary} : {}} onClick={() => this.setState({viewMode: "tiles"})}></Button>
				<Button className={this.state.viewMode === "list" ? "" : "p-button-outlined"} icon="pi pi-list" label="List" style={this.state.viewMode === "list" ? {backgroundColor: colours.primary, borderColor: colours.primary, marginLeft: 6} : {marginLeft: 6}} onClick={() => this.setState({viewMode: "list"})}></Button>
				<Button disabled={!this.state.selectedItems || !this.state.selectedItems.length} icon="pi pi-trash" label="Delete" style={{backgroundColor: colours.graphs.negative, borderColor: colours.graphs.negative, marginRight: 10}} onClick={() => this.setState({showDeleteSelectionModal: true})}></Button>
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
			<div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={()=>{this.globalFilterChange("")}} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilter} onChange={(e)=> {this.globalFilterChange(e)}} placeholder="Keyword Search" />
                </span>
            </div>
				<Button icon="pi pi-upload" label="Export" style={{backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10}} onClick={() => this.dt?.exportCSV()}></Button>
			</>
		);
	}

	async saveItem() {
		this.setState({isLoading: true});
		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			const res = await safeJson(UserService.createSingle(this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!"});
		} else { // Save existing
			const res = await safeJson(UserService.updateSingleById(this.state.selectedItem.id,this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!"});
		}
		this.getItems();
	}

	async updateAccess(i: number, value: any){
		console.log(i);
		console.log(value);
		if(value){
			let newGroupUser: GroupUser = new GroupUser();
			newGroupUser.groupId = i;
			newGroupUser.userId = this.state.selectedItem.id;
			const res = await safeJson(GroupUserService.createSingle(newGroupUser));
				if (res && res.error) {
					this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
					this.setState({isLoading: false});
				} else {
					this.toast.show({closable: false, detail: " Access Updated", life: 5000, severity: "success", summary:" User Management"});
				}
		}
		else {
			let groupUser = this.state.groupUsers.filter(x=>x.groupId == i && x.userId == this.state.selectedItem.id)[0];
			const res = await (await GroupUserService.deleteSingleById(groupUser.id));
				if (res && res.status != 200) {
					this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
					this.setState({isLoading: false});
				}
				else{
					this.toast.show({closable: false, detail: " Access Updated", life: 5000, severity: "success", summary:" User Management"});
				}
		}

		this.getItems();
	}
		
}